export default __webpack_public_path__ + "static/media/123.51cef1a3.jpeg";